import React from 'react';
import { Upload } from 'antd';

const SbUpload = ({ children, ...props }) => {
    return <Upload {...props}>{children}</Upload>;
};

export default SbUpload;
